export const industryList = [
  { value: 'BN00F', name: 'Administracja publiczna' },
  { value: 'BN004', name: 'Budownictwo' },
  { value: 'BN01B', name: 'Chemikalia i farmaceutyki' },
  { value: 'BN005', name: 'Działalność finansowa i ubezpieczeniowa' },
  { value: 'BN026', name: 'Działalność naukowa' },
  { value: 'BN025', name: 'Działalność prawnicza, rachunkowo-księgowa i doradztwo podatkowe' },
  { value: 'BN023', name: 'Działalność związana z kulturą, rozrywką i rekreacją' },
  { value: 'BN01E', name: 'Działalność związana z obsługą rynku nieruchomości, wynajem oraz leasing' },
  { value: 'BN020', name: 'Działalność związana z zakwaterowaniem i usługami gastronomicznymi' },
  { value: 'BN019', name: 'Górnictwo i wydobywanie' },
  { value: 'BN01D', name: 'Handel detaliczny' },
  { value: 'BN01C', name: 'Handel hurtowy' },
  { value: 'BN01F', name: 'Holdingi' },
  { value: 'BN022', name: 'Informacja i komunikacja' },
  { value: 'BN015', name: 'IT / Telekomunikacja' },
  { value: 'BN024', name: 'Opieka zdrowotna i pomoc społeczna' },
  { value: 'BN027', name: 'Organizacje i stowarzyszenia' },
  { value: 'BN021', name: 'Pozostałe usługi (z wyłączeniem administracji publicznej)' },
  { value: 'BN01A', name: 'Produkcja przemysłowa (przetwórstwo)' },
  { value: 'BN001', name: 'Rolnictwo, leśnictwo, rybołówstwo i myślistwo' },
  { value: 'BN00E', name: 'Transport i magazynowanie' },
  { value: 'BN028', name: 'Usługi profesjonalne, naukowe i techniczne' },
  { value: 'BN029', name: 'Wsparcie administracyjne, gospodarowanie odpadami i usuwanie zanieczyszczeń' },
];
